import { takeLatest, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";
import history from "../../../services/history";
import HttpService from "../../../services/HttpService";

import {
	recoverPasswordForPhoneSuccess,
	recoverPasswordForPhoneFail,
	changeLoading,
	sendToken,
	showMessageRecoverFailed,
	recoverPinCodeFailed,
	respAccountRecoverWithType,
} from "./actions";

export function* recoverPasswordForPhoneRequest({ payload }) {
	const { vl_full_phone_number, from_educa } = payload;
	try {
		const response = yield HttpService.sendPhone(vl_full_phone_number, from_educa);
		if (!response.success) {
			throw response;
		}

		sessionStorage.setItem("cd_access_token", response.result.cd_access_token);
		sessionStorage.setItem("vl_full_phone_number", "+" + vl_full_phone_number);

		yield put(recoverPasswordForPhoneSuccess(vl_full_phone_number));

		history.push("/onboard/confirma-fone");
	} catch (err) {
		let message = err.message || "Ocorreu um erro, entre em contato com o administrador";
		let error = err.response.data;

		if (error.message.includes("not a valid phone number")) {
			message = "Por favor, digite um telefone válido";
		}

		toast.error(message);
		yield put(recoverPasswordForPhoneFail());
	}
}

export function* requestAccountRecoverWithType({ payload }) {
	const { vlDocument, documentType, recoveryInfoType, recoveryInfo, operatingSystem, header } = payload;
	try {
		yield put(changeLoading(true));
		const response = yield HttpService.requestAccountRecoverWithType(
			vlDocument,
			documentType,
			recoveryInfoType,
			recoveryInfo,
			"",
			header
		);

		if (!response.success && response.code) {
			toast.error(response.message);
			yield put(changeLoading(false));
			return yield put(showMessageRecoverFailed(true, response));
		}

		yield put(changeLoading(false));
		yield put(respAccountRecoverWithType(response.result));

		if (!response.success) throw response;

		if (operatingSystem === "") {
			history.push({
				pathname: "/onboard/welcome-register",
				search: "",
				state: {
					param: "confirm-pincode",
					token: undefined,
					cpf: vlDocument,
					recoveryInfoType: recoveryInfoType,
					recoveryInfo: recoveryInfo,
				},
			});
		}
	} catch (err) {
		yield put(changeLoading(false));
		let message = err.message || "Ocorreu um erro, entre em contato com o administrador";
		toast.error(message, { progress: 0 });
	}
}

export function* doRecoverAccountWithType({ payload }) {
	const { token, type, value, vlDocument } = payload;
	yield put(changeLoading(true));

	try {
		const response = yield HttpService.doRecoverAccountWithType(token, type, value);
		if (!response.success) {
			yield put(recoverPinCodeFailed(true));

			if (["MANY_ATTEMPTS_BY_PINCODE"].includes(response.code)) throw response;
		}
		yield put(changeLoading(false));

		if (response.success) {
			history.push({
				pathname: "/onboard/welcome-register",
				search: "",
				state: {
					param: "change-password",
					token: undefined,
					cpf: vlDocument,
					recoveryInfoType: type,
					recoveryInfo: value,
				},
			});
			sessionStorage.setItem("token", response.result);
			yield put(sendToken(response.result));
		}
	} catch (err) {
		let message = err.message || "Não foi possível efetuar a validação do token.";
		toast.error(message);
		yield put(changeLoading(false));
	}
}

export function* changePasswordAfterValidate({ payload }) {
	const { token, newPassword, newConfirmPassword } = payload;
	try {
		yield put(changeLoading(true));
		const response = yield HttpService.changePasswordAfterValidate(
			token,
			newPassword,
			newConfirmPassword
		);
		if (!response.success) {
			yield put(changeLoading(false));
			throw response;
		}
		if (response.success) {
			localStorage.setItem("SET_ZERO", true);
			const fluxPromo = JSON.parse(localStorage.getItem("FLUX_PROMO"));
			const routeRedirect = fluxPromo && fluxPromo.route ? fluxPromo.route : "/onboard/login";

			history.push({
				pathname: "/onboard/congratulations",
				state: {
					title: "Pronto! Sua senha foi alterada :)",
					body: "Agora é só entrar na sua conta e aproveitar todas as vantagens do TradeMap!",
					button: "Entrar na minha conta",
					route: routeRedirect,
				},
			});
		}
	} catch (err) {
		yield put(changeLoading(false));
		let message = err.message || "Ocorreu um erro, entre em contato com o administrador";
		toast.error(message);
	}
}

export default all([
	takeLatest("@recover/RECOVER_PASSWORD_FOR_PHONE_REQUEST", recoverPasswordForPhoneRequest),
	takeLatest("@recover/REQUEST_ACCOUNT_RECOVER_WITH_TYPE", requestAccountRecoverWithType),
	takeLatest("@recover/DO_RECOVER_ACOUNT_WITH_TYPE", doRecoverAccountWithType),
	takeLatest("@recover/CHANGE_PASSWORD_AFTER_VALIDATE", changePasswordAfterValidate),
]);
